import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import Profile from '../pages/Profile';
import Dashboard from '../pages/Dashboard';
import Auth from '../pages/Auth';
import SignUpPage from '../pages/SignUpPage';
import FirestoreDemo from '../pages/FirestoreDemo';
import Institutions from '../pages/Institutions';
import FinancialInstitutions from '../pages/FinancialInstitutions';
import CareerSuggester from '../pages/CareerSuggester';
import ProtectedRoute from '../components/ProtectedRoute';
import PrivacyPolicy from '../components/PrivacyPolicy';
import Terms from '../components/Terms';
import LearnMoreTab from '../pages/LearnMore';

const AppRouter = () => (
  <Routes>
    {/* Public routes */}
    <Route path="/auth" element={<Auth />} />
    <Route path="/signup" element={<SignUpPage />} />
    <Route path="/about" element={<About />} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route path="/terms" element={<Terms />} />

    {/* Protected routes */}
    <Route path="/" element={
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    } />
    <Route path="/profile" element={
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    } />
    <Route path="/dashboard" element={
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    } />
    <Route path="/firestore-demo" element={
      <ProtectedRoute>
        <FirestoreDemo />
      </ProtectedRoute>
    } />
    <Route path="/institutions" element={
      <ProtectedRoute>
        <Institutions />
      </ProtectedRoute>
    } />
    <Route path="/financial-institutions" element={
      <ProtectedRoute>
        <FinancialInstitutions />
      </ProtectedRoute>
    } />
    <Route path="/career-suggester" element={
      <ProtectedRoute>
        <CareerSuggester />
      </ProtectedRoute>
    } />
    <Route path="/learn-more" element={
      <ProtectedRoute>
        <LearnMoreTab />
      </ProtectedRoute>
    } />
  </Routes>
);

export default AppRouter;
